//------------------------------
// calc characteristic increase
//------------------------------
export default function calcCharacteristicIncrease(parm) {
  const max = Number(parm.max) || 0
  const improvs_tot = Number(parm.improvs_tot) || 0
  const rolled = Number(parm.rolled) || 0

  const comparisonCurrent = rolled + improvs_tot

  if (comparisonCurrent >= max) {
    return 0
  }
  let incr = Math.round((comparisonCurrent / max) * 100 + 1 - comparisonCurrent)
  return incr
}
